import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-nav" }
const _hoisted_2 = { class: "aside aside-left" }
const _hoisted_3 = {
  href: "https://www.facebook.com/rodamientoshuanuco.ramos",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_4 = {
  href: "https://www.tiktok.com/@rodamientoshuanuc",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_5 = {
  href: "https://www.linkedin.com/in/rodamientos-huanuco-e-i-r-l-a5943048/?originalSubdomain=pe",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_6 = { class: "aside aside-rigth" }
const _hoisted_7 = {
  href: "https://maps.app.goo.gl/eagcpWhMRhJA777N6",
  target: "_blank",
  rel: "noopener noreferrer"
}

import { faFacebook, faLinkedin, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopNav.component',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createElementVNode("ul", null, [
        _cache[0] || (_cache[0] = _createElementVNode("li", { class: "text-social" }, "Visita nuestras redes", -1)),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_3, [
            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faFacebook) }, null, 8, ["icon"])
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_4, [
            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faTiktok) }, null, 8, ["icon"])
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_5, [
            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faLinkedin) }, null, 8, ["icon"])
          ])
        ])
      ])
    ]),
    _createElementVNode("aside", _hoisted_6, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("a", null, [
            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faPhone) }, null, 8, ["icon"]),
            _cache[1] || (_cache[1] = _createTextVNode("  ", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-number" }, "(01) 224-8385", -1))
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_7, [
            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faLocationDot) }, null, 8, ["icon"]),
            _cache[3] || (_cache[3] = _createTextVNode("   ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-location" }, "Av. Aviacion 1954 La Victoria, Lima Perú", -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})